import React, { useState, useId } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { cn } from '../../utils/cn'

interface AccordionProps {
  title: string
  defaultOpen?: boolean
  children: React.ReactNode
  className?: string
}

export function Accordion({ title, defaultOpen = false, children, className }: AccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const panelId = useId()

  return (
    <div className={cn("border border-soft rounded-lg overflow-hidden", className)}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-controls={panelId}
        className="w-full min-h-touch px-4 py-3 bg-surface-alt hover:bg-soft transition-colors flex items-center justify-between"
      >
        <span className="font-medium text-primary">{title}</span>
        {isOpen ? (
          <ChevronUp className="h-5 w-5 text-muted" aria-hidden="true" />
        ) : (
          <ChevronDown className="h-5 w-5 text-muted" aria-hidden="true" />
        )}
      </button>
      {isOpen && (
        <div id={panelId} role="region" aria-label={title} className="p-4 bg-surface">
          {children}
        </div>
      )}
    </div>
  )
}

